<template>
  <div class="main">
    <heads></heads>
    <ctdkbanners></ctdkbanners>
    <div class="content">
      <div class="xtld">
        <div class="xtld-title">
          <div class="xtld-title-icon"></div>
          <div class="xtld-title-text">系统亮点</div>
        </div>
        <div class="xtld-nr">
          <div class="xtld-nr-list">
            <div class="xtld-nr-list-yd">
              <svg
                t="1694488315427"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5973"
                width="60"
                height="60"
              >
                <path
                  d="M387.263 207.84h249.611c-0.77 17.95-3.396 35.26-7.87 52h-233.87c-4.475-16.74-7.102-34.05-7.87-52z m236.583 554H400.291c-5.612 16.85-9.424 34.171-11.47 52h246.496c-2.047-17.829-5.859-35.15-11.47-52z m-209.017-452h194.479c-9.384 17.76-21.233 35.092-35.614 52H450.443c-14.38-16.908-26.23-34.24-35.614-52z m272.375-148.763a391.937 391.937 0 0 1 53.929 32.668c0.913 109.902-46.657 206.619-141.487 288.796-13.751-10.718-28.218-21.168-43.396-31.344 99.748-82.281 142.792-178.316 130.954-290.12z m-351.791 700.83a391.96 391.96 0 0 1-52.13-31.672c4.051-106.235 51.643-200.074 141.725-280.5 12.541 9.467 25.677 18.715 39.402 27.738 1.495 0.982 2.98 1.967 4.455 2.953-94.549 80.45-138.52 173.782-133.452 281.482zM336.95 161c-13.81 130.168 46.76 238.965 184.588 329.568C661.935 582.86 735.736 696.72 740.86 830.133a391.968 391.968 0 0 1-52.122 31.7c6.046-129.049-58.327-237.467-195.763-327.813-140.388-92.286-211.11-206.56-209.96-340.381A391.93 391.93 0 0 1 336.95 161z m225.88 498.84c15.094 16.828 27.834 34.143 38.268 52H423.04c10.434-17.857 23.173-35.172 38.267-52H562.83z"
                  fill="#3889E1"
                  p-id="5974"
                ></path>
                <path
                  d="M512 964c249.633 0 452-202.367 452-452S761.633 60 512 60 60 262.367 60 512s202.367 452 452 452z m0 60C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512z"
                  fill="#3889E1"
                  p-id="5975"
                ></path>
              </svg>
            </div>
            <div class="xtld-nr-list-wz">
              <div class="xtld-nr-list-wz-title">个性匹配</div>
              <div class="xtld-nr-list-wz-con">
                内容挖掘、领域对应、学术动态、期刊偏好
              </div>
            </div>
          </div>
          <div class="xtld-nr-list">
            <div class="xtld-nr-list-yd">
              <svg
                t="1694488811606"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="7141"
                width="60"
                height="60"
              >
                <path
                  d="M256 192.672V96c0-52.928-43.072-96-96-96S64 43.072 64 96v96.672C25.344 221.952 0 267.808 0 320s25.344 98.048 64 127.264V928c0 52.928 43.072 96 96 96s96-43.072 96-96V447.264c38.656-29.184 64-75.072 64-127.264s-25.344-98.048-64-127.328zM128 96a32 32 0 1 1 64 0v67.2a161.984 161.984 0 0 0-64 0V96z m64 832a32 32 0 1 1-64 0V476.736a157.312 157.312 0 0 0 64 0V928z m59.68-581.12c-0.512 1.696-0.96 3.36-1.568 5.056a94.208 94.208 0 0 1-12.096 23.552l-0.448 0.512a96.832 96.832 0 0 1-19.712 20.064l-0.32 0.256c-7.712 5.824-16.32 10.496-25.568 13.76-10.016 3.616-20.672 5.92-31.968 5.92s-21.952-2.304-32-5.952a94.784 94.784 0 0 1-25.568-13.76l-0.32-0.256a96.832 96.832 0 0 1-19.712-20.064l-0.448-0.512a95.328 95.328 0 0 1-12.096-23.552c-0.608-1.696-1.056-3.36-1.568-5.056A94.24 94.24 0 0 1 64 320c0-9.44 1.76-18.368 4.32-26.944 0.512-1.696 0.96-3.36 1.568-4.992 3.008-8.448 6.912-16.448 12.096-23.616l0.448-0.512c5.568-7.552 12.192-14.368 19.712-20.064l0.32-0.256c7.68-5.728 16.288-10.432 25.536-13.728C138.048 226.304 148.704 224 160 224s21.952 2.304 32 5.888c9.248 3.328 17.856 8 25.568 13.76l0.32 0.256c7.52 5.696 14.144 12.512 19.712 20.064l0.448 0.512a93.792 93.792 0 0 1 13.632 28.576c2.56 8.576 4.32 17.504 4.32 26.944 0 9.376-1.76 18.304-4.32 26.88zM960 192.672V96c0-52.928-43.072-96-96-96s-96 43.072-96 96v96.672c-38.688 29.28-64 75.136-64 127.328s25.312 98.048 64 127.264V928c0 52.928 43.072 96 96 96s96-43.072 96-96V447.264c38.624-29.184 64-75.072 64-127.264s-25.376-98.048-64-127.328zM832 96a32 32 0 1 1 64 0v67.2a162.464 162.464 0 0 0-64 0V96z m64 832a32 32 0 1 1-64 0V476.736a156.864 156.864 0 0 0 64 0V928z m59.68-581.12c-0.512 1.696-0.992 3.36-1.568 5.056a94.304 94.304 0 0 1-12.128 23.552l-0.448 0.512a97.472 97.472 0 0 1-19.68 20.064l-0.32 0.256c-7.744 5.824-16.32 10.496-25.568 13.76A93.824 93.824 0 0 1 864 416a93.12 93.12 0 0 1-32-5.952 94.304 94.304 0 0 1-25.888-14.016 96.192 96.192 0 0 1-19.744-20.064l-0.448-0.512a95.2 95.2 0 0 1-12.064-23.552c-0.64-1.696-1.056-3.36-1.568-5.056A94.24 94.24 0 0 1 768 320c0-9.44 1.76-18.368 4.32-26.944 0.512-1.696 0.928-3.36 1.568-4.992 3.008-8.448 6.944-16.448 12.064-23.616l0.448-0.512c5.568-7.552 12.192-14.368 19.744-20.064l0.32-0.256c7.68-5.76 16.32-10.432 25.568-13.76A95.04 95.04 0 0 1 864 224c11.264 0 21.952 2.304 32 5.888a98.976 98.976 0 0 1 25.888 14.016c7.488 5.696 14.112 12.512 19.68 20.064l0.448 0.512c5.184 7.2 9.056 15.2 12.128 23.616 0.576 1.632 1.056 3.328 1.568 4.992 2.528 8.544 4.288 17.472 4.288 26.912 0 9.376-1.76 18.304-4.32 26.88zM608 576.672V96c0-52.928-43.072-96-96-96s-96 43.072-96 96v480.672c-38.656 29.248-64 75.136-64 127.328s25.344 98.048 64 127.264V928c0 52.928 43.072 96 96 96s96-43.072 96-96v-96.736c38.624-29.184 64-75.072 64-127.264s-25.376-98.048-64-127.328zM480 96a32 32 0 1 1 64 0v451.2a161.984 161.984 0 0 0-64 0V96z m64 832a32 32 0 1 1-64 0v-67.264a157.312 157.312 0 0 0 64 0V928z m59.68-197.12c-0.512 1.696-0.992 3.36-1.568 5.056a94.304 94.304 0 0 1-12.128 23.552l-0.448 0.512a97.472 97.472 0 0 1-19.68 20.064l-0.32 0.256c-7.744 5.824-16.32 10.496-25.568 13.76A93.824 93.824 0 0 1 512 800c-11.296 0-21.952-2.304-32-5.952a94.784 94.784 0 0 1-25.568-13.76l-0.32-0.256a96.832 96.832 0 0 1-19.712-20.064l-0.448-0.512a95.328 95.328 0 0 1-12.096-23.552c-0.608-1.696-1.056-3.36-1.568-5.056A94.24 94.24 0 0 1 416 704c0-9.44 1.76-18.368 4.32-26.944 0.512-1.696 0.96-3.36 1.568-4.992 3.04-8.448 6.944-16.448 12.096-23.616l0.448-0.512c5.568-7.552 12.192-14.368 19.712-20.064l0.32-0.256c7.712-5.76 16.32-10.432 25.568-13.76 10.016-3.552 20.672-5.856 31.968-5.856 11.264 0 21.952 2.304 32 5.888a98.976 98.976 0 0 1 25.888 14.016c7.488 5.696 14.112 12.512 19.68 20.064l0.448 0.512c5.184 7.2 9.056 15.2 12.128 23.616 0.576 1.632 1.056 3.328 1.568 4.992 2.528 8.544 4.288 17.472 4.288 26.912 0 9.376-1.76 18.304-4.32 26.88z"
                  fill="#3889E1"
                  p-id="7142"
                ></path>
              </svg>
            </div>
            <div class="xtld-nr-list-wz">
              <div class="xtld-nr-list-wz-title">智能筛选</div>
              <div class="xtld-nr-list-wz-con">
                领域关联、前瞻预判、文刊融合、期刊推荐
              </div>
            </div>
          </div>
          <div class="xtld-nr-list">
            <div class="xtld-nr-list-yd">
              <svg
                t="1694488866186"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="10442"
                width="60"
                height="60"
              >
                <path
                  d="M515.456 148.48c168.661333-86.186667 330.154667-94.890667 408.746667-7.637333 72.874667 80.938667 56.192 224.213333-29.098667 371.2 85.290667 146.944 101.973333 290.176 29.098667 371.114666-79.104 87.850667-242.261333 78.421333-412.16-9.429333-169.941333 87.850667-333.141333 97.28-412.245334 9.386667C26.922667 802.261333 43.605333 659.029333 128.853333 512 43.605333 365.056 26.922667 221.781333 99.84 140.842667c79.061333-87.850667 242.261333-78.421333 412.16 9.472z m326.314667 443.904l-8.106667 10.666667a995.285333 995.285333 0 0 1-121.813333 130.901333 1010.858667 1010.858667 0 0 1-111.445334 87.210667c117.12 49.706667 217.941333 52.053333 260.394667 4.864 39.253333-43.605333 31.189333-132.48-19.029333-233.642667z m-659.541334 0.085333c-50.261333 101.248-58.24 190.037333-19.029333 233.557334 42.453333 47.146667 143.274667 44.842667 260.394667-4.821334a1016.064 1016.064 0 0 1-111.445334-87.253333 989.184 989.184 0 0 1-129.92-141.482667z m329.813334-344.618666l-6.656 3.968a909.226667 909.226667 0 0 0-136.106667 101.632A888.405333 888.405333 0 0 0 229.546667 512a888.746667 888.746667 0 0 0 139.648 158.549333 905.642667 905.642667 0 0 0 142.805333 105.642667 907.946667 907.946667 0 0 0 142.72-105.642667A888.405333 888.405333 0 0 0 794.410667 512a888.192 888.192 0 0 0-139.648-158.549333A905.642667 905.642667 0 0 0 512 247.893333zM512 384a128 128 0 1 1 0 256 128 128 0 0 1 0-256z m0 85.333333a42.666667 42.666667 0 1 0 0 85.333334 42.666667 42.666667 0 0 0 0-85.333334z m348.8-271.36c-42.453333-47.146667-143.274667-44.842667-260.394667 4.821334 37.76 25.472 75.178667 54.613333 111.445334 87.253333a989.141333 989.141333 0 0 1 129.92 141.525333c50.218667-101.12 58.282667-189.994667 19.029333-233.6z m-697.6 0c-39.253333 43.562667-31.189333 132.437333 18.986667 233.6a990.805333 990.805333 0 0 1 129.962666-141.525333 1010.858667 1010.858667 0 0 1 111.445334-87.210667C306.474667 153.130667 205.653333 150.784 163.2 197.973333z"
                  fill="#3889E1"
                  opacity=".65"
                  p-id="10443"
                ></path>
              </svg>
            </div>
            <div class="xtld-nr-list-wz">
              <div class="xtld-nr-list-wz-title">导投决策</div>
              <div class="xtld-nr-list-wz-con">
                影响因子、发表价值、用途规划、综合评估
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xtld">
        <div class="xtld-title">
          <div class="xtld-title-icon"></div>
          <div class="xtld-title-text">报告示例</div>
        </div>
        <div class="xtld-nr">
          <div class="bgsl-list">
            <el-image  :preview-src-list="srcList" :initial-index='0' style="width: 360px; height:400px;" src="/img/index/selectedGournal1.png" fit="fill" />
          </div>
          <div class="bgsl-list">
            <el-image  :preview-src-list="srcList" :initial-index='1' style="width: 360px; height:400px;" src="/img/index/selectedGournal2.png" fit="fill" />
          </div>
          <div class="bgsl-list">
            <el-image  :preview-src-list="srcList" :initial-index='2' style="width: 360px; height:400px;" src="/img/index/selectedGournal3.png" fit="fill" />
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
const srcList=[
  '/img/index/yuan1.png',
  '/img/index/yuan2.png',
  '/img/index/yuan3.png',
]
</script>

<style scoped>
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  padding: 40px 0;
  margin: auto;
}
.xtld {
  padding-bottom: 40px;
}
.xtld-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.xtld-title-icon {
  width: 5px;
  height: 18px;
  background: #3476fe;
  border-radius: 8px;
}
.xtld-title-text {
  font-size: 18px;
  font-weight: bold;
  color: #444;
  margin-left: 10px;
}
.xtld-nr {
  display: flex;
  justify-content: space-between;
}
.xtld-nr-list {
  width: 380px;
  height: 140px;
  background: #fff;
  box-shadow: 0 2px 0.72rem #e0e2e663;
  padding: 15px 20px;
  box-sizing: border-box;
}
.xtld-nr-list-yd {
  width: 110px;
  height: 110px;
  float: left;
  border-radius: 50%;
  background: #e1edfb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.xtld-nr-list-wz {
  width: 230px;
  height: 110px;
  padding-left: 10px;
  box-sizing: border-box;
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.xtld-nr-list-wz-title {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
}
.bgsl-list {
  width: 360px;
  height: 400px;
  border: 1px solid #eee;
  box-shadow: 0 7px 0.75rem #e0e2e6d9;
  cursor: pointer;
}
.bgsl-list:hover{
  box-shadow: 0 0.7rem 1.36rem 6px #e0e2e6d9;
}
</style>
